import { defineComponent as _defineComponent } from 'vue';
import { SModal } from '@strana-artw/ui-kit';
import { defineComponent, ref } from 'vue';
import HeaderLoyaltyButton from '@/components/layout/next/parts/Loyalty/HeaderLoyaltyButton.vue';
import { ContactsContent } from '@/entities/manager/ui';
import { CertifiedPartner } from '@/features/certified-partner/ui';
import LoyaltyMenuItem from '@/features/loyalty/ui/LoyaltyMenuItem.vue';
import { HeaderProfileButton } from '@/features/user-profile';
import { useModalHandler } from '@/plugins/modal';
import { useScreenPlugin } from '@/plugins/vue-screen';
import { NavButton } from '@/shared/ui';
import { FLAGS, useFeatureFlagsStore } from '@/store/featureFlags';
export default /*#__PURE__*/_defineComponent({
  __name: 'MenuMobileHead',
  emits: ["menu-item-click"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    defineComponent({
      name: 'MenuMobileHead'
    });
    var screen = useScreenPlugin();
    var featureFlagsStore = useFeatureFlagsStore();
    var hasSupportFlag = featureFlagsStore.isEnabledFlag(FLAGS.support);
    var isHeaderNew = featureFlagsStore.isHeaderNew;
    var $modal = useModalHandler();
    var contactsOpen = ref(false);
    var handleSupport = function handleSupport() {
      $modal.open({
        component: 'ModalTechSupport',
        overlay: false,
        transition: null
      });
    };
    function onContactsOpen() {
      contactsOpen.value = true;
    }
    function onContactsClose() {
      contactsOpen.value = false;
    }
    return {
      __sfc: true,
      emit: emit,
      screen: screen,
      featureFlagsStore: featureFlagsStore,
      hasSupportFlag: hasSupportFlag,
      isHeaderNew: isHeaderNew,
      $modal: $modal,
      contactsOpen: contactsOpen,
      handleSupport: handleSupport,
      onContactsOpen: onContactsOpen,
      onContactsClose: onContactsClose,
      SModal: SModal,
      HeaderLoyaltyButton: HeaderLoyaltyButton,
      ContactsContent: ContactsContent,
      CertifiedPartner: CertifiedPartner,
      LoyaltyMenuItem: LoyaltyMenuItem,
      HeaderProfileButton: HeaderProfileButton,
      NavButton: NavButton
    };
  }
});